import React, { useEffect, useState } from "react";
import IntlMessages from "@iso/components/utility/intlMessages";
import { Col } from "antd";
import { useLocation } from "react-router-dom";
import PaymentsTable from "../PaymentsTable/PaymentsTable";
import SectionTitle from "@iso/components/SectionTitle/SectionTitle";
import Container from "../../components/Container/Container";

export default function PaymentResult() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [message, setMessage] = useState();
  const [state, setState] = useState(null);

  useEffect(() => {
    const status = searchParams.get("redirect_status");
    setState(status);
    if (status !== "succeeded") {
      const message = searchParams.get("message");
      setMessage(message);
    }
  }, []);

  return (
    <>
      <Col md={8} sm={24}>
        <SectionTitle>
          <IntlMessages id="page.myAccount.financial.actualBalance.title" />
        </SectionTitle>
      </Col>

      <Col md={16} sm={24}>
        <SectionTitle>
          <IntlMessages id="page.myAccount.financial.lastPayments.title" />
        </SectionTitle>
        <ul>
          <PaymentsTable dataList={[]} />
        </ul>
      </Col>
    </>
  );
}
